import React, {useContext, useEffect, useState} from 'react';
import PageIntroSection from "../components/PageIntroSection/PageIntroSection";
import RestaurantItem from "../components/Restourant-item/RestaurantItem";
import {LangContext} from "../App";
import {axios} from "../axios";
import hotelImage from "../assets/images/test/hotelImage.jpg";
import Seo from "../components/Seo/Seo";

const Restaurant = () => {
    const [data,setData] = useState([
        {title:'tufta restoran'},
        {title:'bldo'}
    ])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/restaurant`)
            .then(res => setData(res.data.tours))
    },[lang])
    return (
        <div className='restaurant'>
            <Seo pageKey="restaurants" />
            <PageIntroSection title='Lorem Ipsum'
                              image={hotelImage}
                              text='Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam consectetur distinctio libero rerum voluptate voluptatum?'
            />
            <div className="center-wrapper">
                <div className="restaurant-list">
                    {data.map(e => <RestaurantItem path='restaurant-page' key={e.id} tour={e}/>)}
                </div>
            </div>
        </div>
    );
};

export default Restaurant;